// extracted by mini-css-extract-plugin
export default {"card":"card_card__W15qC","childCard":"card_childCard__5s56j","toggle":"card_toggle__WkicW","collapsed":"card_collapsed__Th9rt"};